var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-relative"},[_vm._t("default"),(_vm.lock)?_c('div',{staticClass:"tw-absolute tw-inline-block tw--ml-7 tw-mt-[6px] tw-text-gray-400"},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-lock")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }